import { useState, useEffect } from 'react';
import { IAnalyticsTotalPlacements, getTotalPlacements } from 'wisestep-api';

import { IClientsAnalyticsAPIProps } from '../helper/payloadsAndTypesHelper';

const useGetTotalPlacements = (clientsAnalyticsChartsProps: IClientsAnalyticsAPIProps) => {
  const [data, setData] = useState<IAnalyticsTotalPlacements[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getTotalPlacements(clientsAnalyticsChartsProps.period);
      setData(response.data);
    };
    fetchData();
  }, [clientsAnalyticsChartsProps]);
  return data;
};

export default useGetTotalPlacements;
